/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Bags_DescInputs */

const vi_sinp_bags_desc = /** @type {(inputs: Sinp_Bags_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu có hàng tính theo kg. Nhập số bao của từng dòng để in kèm trên phiếu; dòng không đóng bao thì để trống.`)
};

/**

* @param {Sinp_Bags_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_bags_desc = /** @type {((inputs?: Sinp_Bags_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Bags_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_bags_desc(inputs)
});